import { render, staticRenderFns } from "./CalculatorProductSelector.vue?vue&type=template&id=52deeb67&scoped=true"
import script from "./CalculatorProductSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalculatorProductSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CalculatorProductSelector.vue?vue&type=style&index=0&id=52deeb67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52deeb67",
  null
  
)

export default component.exports